export default __webpack_public_path__ + "static/media/Member-login-Registration-gold.fb7cfed0.png";